import { render, staticRenderFns } from "./meituan.vue?vue&type=template&id=2795edd5&scoped=true&"
import script from "./meituan.vue?vue&type=script&lang=js&"
export * from "./meituan.vue?vue&type=script&lang=js&"
import style0 from "./meituan.vue?vue&type=style&index=0&id=2795edd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795edd5",
  null
  
)

export default component.exports